// Example: src/data/hire-javascript-data.js

export const hireJavascriptPageContent = {
  // Helmet Content
  helmet: {
    title: "Hire JavaScript Developers | JavaScript Development Services",
    description: "Hire professional JavaScript developers for dynamic, responsive web apps. Expert JavaScript services tailored to your project goals.",
  },

  // Main Banner Content
  mainBanner: {
    backgroundImage: `url(/images/hire-page-images/hire-javascript.avif)`,
    image: "", // Keep if explicitly needed, otherwise can remove
    mainHeading: "Hire Javascript Developers",
    content: "Looking for skilled JavaScript developers? Bitsclan provides top remote JavaScript developers, perfect for startups & enterprises seeking high-performance web solutions.",
    btnText: "Consult our javascript developers",
    bannerList: [
      { list: "Flexible Hiring Options" },
      { list: "Full-time roles" },
      { list: "Global teams" },
    ],
  },

  // JavaScript Expertise Section
  jsExpertise: {
    btnText: "Schedule a Call Today",
    heading: "Our JavaScript Developer Expertise",
    description: "At Bitsclan, our JavaScript developers specialize in building dynamic, scalable, & high-performance web applications. We ensure seamless functionality, smooth user experiences, & cutting-edge solutions for your business.",
    servicesData: [
      {
        title: "Javascript Consulting",
        description: "Need expert guidance for your JavaScript project? Our experienced developers provide strategic advice to enhance performance, scalability, & efficiency, ensuring you achieve your business goals.",
        icon: "/images/hire-page-icons/hire-javascrip-icon1.svg",
      },
      {
        title: "Javascript web Development",
        description: " We specialize in building powerful, feature-rich, & scalable web applications with JavaScript. Our experts ensure smooth performance, enhanced functionality, & an outstanding user experience.",
        icon: "/images/hire-page-icons/hire-javascrip-icon2.svg",
      },
      {
        title: "Javascript API Development",
        description: "Our JavaScript developers build robust & secure APIs, enabling seamless integration & communication between applications, third-party services, & platforms.",
        icon: "/images/hire-page-icons/hire-javascrip-icon3.svg",
      },
      {
        title: "JavaScript CMS & Portal Development",
        description: "Looking for a powerful CMS or web portal? Our JavaScript developers build scalable & user-friendly content management systems that streamline content management & user interactions.",
        icon: "/images/hire-page-icons/hire-javascrip-icon4.svg",
      },
      {
        title: "Migration to Javascript",
        description: "Planning to migrate your existing system to JavaScript? Our experts ensure a seamless transition with minimal downtime, enhancing performance & scalability.",
        icon: "/images/hire-page-icons/hire-javascrip-icon5.svg",
      },
      {
        title: "Integration with Existing Solutions",
        description: "Our JavaScript experts seamlessly integrate your applications with third-party services, APIs, & platforms, ensuring smooth workflows & improved functionality.",
        icon: "/images/hire-page-icons/hire-javascrip-icon6.svg",
      },
      {
        title: "Javascript eCommerce Solutions",
        description: "We build high-performance eCommerce solutions with JavaScript, offering secure payment gateways, intuitive navigation, & scalable architecture to boost conversions.",
        icon: "/images/hire-page-icons/hire-javascrip-icon7.svg",
      },
      {
        title: "Javascript Support & Maintenance",
        description: "Keep your JavaScript application secure & optimized with our continuous support & maintenance services. We handle updates, bug fixes, & performance enhancements.",
        icon: "/images/hire-page-icons/hire-javascrip-icon8.svg",
      },
    ],
  },

  // Why Choose Us (Development Performance)
  whyChooseUs: {
    btnText: "Hire a developer today",
    heading: "Why Hire JavaScript Developers ",
    greenHeading: "from Bitsclan?",
    subHeading: "At Bitsclan, we specialize in building high-performance applications by integrating JavaScript with modern frontend, backend, & mobile technologies.",
    solutionsData: [
      {
        icon: "/images/hire-page-icons/chose-ror-section1.svg",
        title: "Access vetted talent",
        description: "When you hire JavaScript developers with us, you get access to professionals who are fully vetted for their skills, experience, & English fluency, ensuring they can contribute effectively to your project.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section2.svg",
        title: "View matches in seconds",
        description: "Forget going through hundreds of resumes! With our HireAI system, you can instantly find JavaScript developers for hire & match with the right talent for your project in just a few seconds.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section3.svg",
        title: "Save with global hires",
        description: "By hiring globally, you can access over 450,000 talented professionals from 190 countries. This can save you up to 58% compared to traditional hiring methods, while still getting the best developers for your JavaScript development services.",
        noBorder: true,
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section4.svg",
        title: "Get real human support",
        description: "At Bitsclan, we don't leave you on your own. You’ll receive personalized assistance from our team of expert recruiters to ensure you hire the right JavaScript developer for your needs.",
      },
    ],
  },

  // Technology Combinations
  techCombinations: {
    heading: "Top JavaScript Combinations for Outstanding Development",
    description: "Unlock the full potential of JavaScript by leveraging the most effective technology combinations. Hire expert JavaScript developers to build high-performing, scalable, & innovative solutions tailored to your needs.",
    combinations: [
      {
        title: "JavaScript + React + Firebase",
        description:
          "JavaScript as the core language, React for a dynamic front-end, & Firebase as a real-time database help build interactive & serverless web applications.",
        icons: [
          { icon: "javascript.svg", altText: "JavaScript programming language" },
          { icon: "react.svg", altText: "React.js frontend library" },
          { icon: "firebase.png", altText: "Firebase real-time database" },
        ],
      },
      {
        title: "JavaScript + Angular + Node.js",
        description:
          "Angular on the front end, Node.js as the backend, & JavaScript across the stack enable efficient full-stack development for scalable applications.",
        icons: [
          { icon: "javascript.svg", altText: "JavaScript programming language" },
          { icon: "angular.svg", altText: "Angular front-end framework" },
          { icon: "nodejs.svg", altText: "Node.js backend runtime" },
        ],
      },
      {
        title: "JavaScript + Vue.js + PostgreSQL",
        description:
          "Vue.js for a lightweight front-end, JavaScript-powered logic, & PostgreSQL as a relational database ensure a balanced & efficient web stack.",
        icons: [
          { icon: "javascript.svg", altText: "JavaScript programming language" },
          { icon: "vue-js.svg", altText: "Vue.js frontend framework" },
          { icon: "postgres.svg", altText: "PostgreSQL database" },
        ],
      },
      {
        title: "JavaScript + Express.js + MongoDB",
        description:
          "Express.js as a lightweight backend framework, JavaScript for handling logic, & MongoDB as a NoSQL database create a fast & flexible web solution.",
        icons: [
          { icon: "javascript.svg", altText: "JavaScript programming language" },
          { icon: "express.svg", altText: "Express.js backend framework" },
          { icon: "mongodb.svg", altText: "MongoDB NoSQL database" },
        ],
      },
    ],
  },

  // Hire Steps
  hireSteps: {
    btnText: "Let’s Find Your Perfect Developer",
    heading: "Hire JavaScript Developers in 4 Easy Steps",
    subHeading: "Hiring expert JavaScript developers has never been easier. Follow our simple 4-step process to find the perfect developers for your project.",
    steps: [
      {
        title: "Choose your Engagement Model",
        description: "Select the engagement model that works best for you whether Full-Time, Part-Time, or Hourly. We give you the flexibility to choose what suits your project.",
        icon: "/images/hire-page-setps-icons/icon-1.svg",
      },
      {
        title: "Screen & Select Javascript Developers",
        description: "Browse through profiles of top JavaScript developers for hire. Choose the best candidates to continue with the process.",
        icon: "/images/hire-page-setps-icons/icon-2.svg",
      },
      {
        title: "Conduct One-on-One Interview",
        description: "Interview the shortlisted candidates & test their skills with both theoretical & practical questions. This step helps ensure you get the right fit for your project.",
        icon: "/images/hire-page-setps-icons/icon-3.svg",
      },
      {
        title: "Javascript Developers",
        description: "Once you finalize your choice, the selected JavaScript developer will join your team within 24-48 hours, ready to start working on your project.",
        icon: "/images/hire-page-setps-icons/icon-4.svg",
      },
    ],
  },

  // Cover The Stack
  coverTheStack: {
    whereStart: "Languages & Frameworks",
    mainHeading: "Hire Expert JavaScript Developers for Dynamic & Scalable Web Solutions",
    subHeading: "At Bitsclan, we empower your web development journey with a cutting-edge JavaScript tech stack that ensures interactivity, scalability, & performance. Our skilled JavaScript developers specialize in building responsive, high-performance web applications tailored to your business needs.",
    tabs: [
      "Languages & Frameworks",
      "Libraries",
      "Frameworks",
    ],
    tabItems: [
      { tab: "Languages & Frameworks", icon: "/images/tech-stack-icons/java.svg", name: "Java" },
      { tab: "Languages & Frameworks", icon: "/images/tech-stack-icons/kotlin.svg", name: "Kotlin" },
      { tab: "Languages & Frameworks", icon: "/images/tech-stack-icons/android-sdk.svg", name: "Android SDK" },
      { tab: "Languages & Frameworks", icon: "/images/tech-stack-icons/jetpack-compose.svg", name: "Jetpack Compose" },
      { tab: "Languages & Frameworks", icon: "/images/tech-stack-icons/android-jetpack.svg", name: "Android Jetpack" },
      { tab: "Libraries", icon: "/images/tech-icon.svg", name: "PyTorch" },
      { tab: "Libraries", icon: "/images/tech-icon2.svg", name: "Keras" },
      { tab: "Libraries", icon: "/images/tech-icon3.svg", name: "MXNet" },
      { tab: "Libraries", icon: "/images/libraries1.svg", name: "FastAI" },
      { tab: "Libraries", icon: "/images/libraries2.svg", name: "TensorFlow" },
      { tab: "Libraries", icon: "/images/libraries3.svg", name: "Theano" },
      { tab: "Libraries", icon: "/images/libraries4.svg", name: "Scikit-learn" },
      { tab: "Frameworks", icon: "/images/iconone.png", name: "Angular JS" },
      { tab: "Frameworks", icon: "/images/node.svg", name: "Node JS" },
      { tab: "Frameworks", icon: "/images/tech-stack-icons/vue-js.svg", name: "Vue.JS" },
      { tab: "Frameworks", icon: "/images/database5.png", name: "Express JS" },
      { tab: "Frameworks", icon: "database3.png", name: "Meteor JS" },
    ],
  },

  // Expert Facts
  expertFacts: {
    btnText: "book an appointment",
    heading: "Quick Facts About ",
    greenHeading: "Our JavaScript Team",
    facts: [
      { text: "40+ expert JavaScript developers ready to build & scale your applications." },
      { text: "Developers with 6+ years of experience in front-end & back-end JavaScript technologies." },
      { text: "Skilled in modern frameworks like React.js, Vue.js, & Node.js for dynamic web development." },
      { text: "Expertise in serverless computing, cloud-native development, & API integrations." },
      { text: "Proficient in emerging technologies like AI, IoT, & big data solutions." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-javascript.avif)`, // From mainBannerImg.factBackgroundImage
  },

  // App Idea Section
  appIdeaSection: {
    heading: "Turn Your App Idea into a Working Prototype in Just Weeks!", // Added for consistency
    content: "Have an idea but don’t know where to start? Our JavaScript experts can help you build a working prototype in just 6-8 weeks! Validate your vision, test user engagement, & create a solid foundation for success.",
  },

  // Engagement Models
  hirePageEngagementModels: {
    btnText: "Get Started Now",
    headingContent: [
      { text: "Our Flexible" },
      { text: "Engagement Models" },
    ],
    discription: "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly developers, we offer flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",
    hiringDetails: [
      {
        text: "Hourly Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "time.svg",
        bgColor: "#FDFDFF",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Start work in "
      },
      {
        text: "Full Time Hiring",
        hours: "72",
        timeUnit: "hours",
        icon: "full-time.svg",
        bgColor: "#FFFEFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Get started within "
      },
      {
        text: "Part Time Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "part-time.svg",
        bgColor: "#FDFFFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Launch in "
      },
    ],
  },

  // FAQ Section
  faqSection: {
    mainHeading: "Frequently Asked Questions",
    subHeading: "Explore our Javascript development services for tailored web solutions, API creation, & deployment management!",
    faqData: [
      {
        id: "collapseOne",
        question: "What is JavaScript & why should I use it?",
        answer: "JavaScript is a popular programming language used to create interactive & dynamic web pages. It helps make websites more engaging by allowing features like animations, form validations, & interactive maps. If you want a website that is more than just static pages, JavaScript is a great choice.",
      },
      {
        id: "collapseTwo",
        question: "Why should I hire JavaScript developers?",
        answer: "Hiring JavaScript developers ensures that you get experts who can build high-quality, interactive websites or web applications. They know how to make your website work smoothly on different devices, providing a better user experience.",
      },
      {
        id: "collapseThree",
        question: "How do I know if I need JavaScript for my project?",
        answer: "If you want a dynamic website that interacts with users, like forms, animations, or live updates, JavaScript is essential. It’s also useful for building apps & websites that require real-time data, such as e-commerce sites or social media platforms.",
      },
      {
        id: "fourth",
        question: "How can I hire the best JavaScript developers?",
        answer: "You can hire JavaScript developers by looking for professionals with experience in building interactive & dynamic websites. It’s important to review their past projects, check their skills, & make sure they understand your project’s goals.",
      },
      {
        id: "fifth",
        question: "How long does it take to build a JavaScript web application?",
        answer: "The time it takes to build a JavaScript web application depends on the complexity of the project. Simple websites might take a few weeks, while more complex web applications may take several months. It’s important to discuss timelines with your development team.",
      },
      {
        id: "sixth",
        question: "What are the benefits of hiring JavaScript developers from Bitsclan?",
        answer: "At Bitsclan, we have experienced JavaScript developers for hire who are skilled in building dynamic, high-performance web applications. We ensure quick onboarding, clear communication, & deliver solutions that meet your business needs.",
      },
    ],
  },
};